import { template as template_5387812636f0467faddeaef850ba1ce5 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import BsButton from 'eflex/components/bs-button';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';
import BsTooltip from 'eflex/components/bs-tooltip';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import AddButton from 'eflex/components/add-button';
import { t } from 'ember-intl';
import { or, not } from 'ember-truth-helpers';
import Link from 'eflex/components/link';
import { hash } from '@ember/helper';
export default class WorkInstructionEditorHeader extends Component {
    @service
    imageEditor;
    static{
        template_5387812636f0467faddeaef850ba1ce5(`
    <div class="work-instruction-editor-controls row align-items-center" ...attributes>
      <div class="col">
        <div class="row align-items-center g-3">
          <div class="col-auto">
            <Link
              class="btn-library"
              @type="secondary"
              @route="workInstructions"
              @query={{hash folderId=null}}
            >
              <FaIcon @icon="caret-left" class="me-1" @size="sm" />
              {{t "library"}}
            </Link>
          </div>
          <div class="col-auto">
            <div class="work-instruction-title-container d-flex align-items-center">
              {{#if @workInstruction.folder}}
                <div class="d-flex align-items-center text-truncate mx-2">
                  <Link
                    class="btn-library-folder link-gray-900 text-truncate"
                    @route="workInstructions"
                    @query={{hash folderId=@workInstruction.folder.id}}
                  >
                    {{@workInstruction.folder.name}}
                    <BsTooltip @title={{@workInstruction.folder.name}} @delayShow={{600}} />
                  </Link>
                  <span class="text-gray-500 mx-2">/</span>
                </div>
              {{/if}}

              <h5 class="work-instruction-title-name text-truncate mb-0 me-2">
                {{@title}}
              </h5>
              {{#if @workInstruction}}
                <div class="col-auto">
                  <BsDropdown
                    @direction="bottom"
                    as |dd|>
                    <dd.toggle class="btn-dropdown d-block h-100">
                      <BsButton
                        @type="secondary"
                        class="current-library-item-controls border-0 transition-none d-flex p-2"
                        >
                        <FaIcon @icon="ellipsis" @prefix="fas" class="fa-fw" />
                      </BsButton>
                    </dd.toggle>

                    <dd.menu class="dropdown-menu" as |menu|>
                      <div class="py-1">
                        <menu.item>
                          <BsButton
                            class="wie-duplicate-button dropdown-item"
                            @size="sm"
                            @disabled={{@canEdit}}
                            @onClick={{@duplicateInstruction}}
                          >
                            <FaIcon @icon="copy" @prefix="fas" class="fa-fw me-1" />
                            {{t "createCopy"}}
                          </BsButton>
                        </menu.item>
                      </div>
                    </dd.menu>
                  </BsDropdown>
                </div>
              {{/if}}
            </div>
          </div>
          {{#if @workInstruction}}
            <div class="col-auto d-flex align-items-center">
              <div class="row align-items-center g-0">
                <div class="col-auto">
                  <BsButton
                    @disabled={{or (not this.imageEditor.canUndo) @actionsDisabled}}
                    @onClick={{@undo}}
                    class="undo-button border-0 transition-none d-flex p-2"
                  >
                    <FaIcon @icon="rotate-left" @prefix="fas" class="fa-fw" />
                    <BsTooltip @title="{{t "undo"}} — Ctrl Z" @delayShow={{600}} />
                  </BsButton>
                </div>
                <div class="col-auto">
                  <BsButton
                    @disabled={{or (not this.imageEditor.canRedo) @actionsDisabled}}
                    @onClick={{@redo}}
                    class="redo-button border-0 transition-none d-flex p-2"
                  >
                    <FaIcon @icon="rotate-right" @prefix="fas" class="fa-fw" />
                    <BsTooltip @title="{{t "redo"}} — &#8679; Ctrl Z" @delayShow={{600}} />
                  </BsButton>
                </div>
              </div>

              <div class="row align-items-center g-0">
                <div class="save col-auto">
                  {{yield}}
                </div>
              </div>
            </div>
          {{/if}}
        </div>
      </div>
      <div class="col-auto">
        <AddButton
          class="wie-create-button ms-auto"
          @disabled={{not @canCreate}}
          @onClick={{@createStart}}
        >
          {{t "create"}}
        </AddButton>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
}
